import { Button, ModalCloseButton, ModalFooter } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';

import { DefaultContent } from './DefaultContent';
import { usePendingBatchesDrawer } from './usePendingBatchesDrawer';

export * from './usePendingBatchesDrawer';

export const PendingBatchesDrawer = () => {
  const t = useTranslations();
  const isOpen = usePendingBatchesDrawer((s) => s.isOpen);
  const onClose = usePendingBatchesDrawer((s) => s.onClose);

  return (
    <ModalOrDrawer
      placement="bottom"
      scrollBehavior="inside"
      isOpen={isOpen}
      onClose={onClose}
      size={{
        base: 'full',
        desktop: 'md',
      }}
    >
      <ModalOrDrawerOverlay />
      <ModalOrDragDrawerContent>
        <InDesktop>
          <ModalCloseButton />
        </InDesktop>
        <ModalOrDrawerHeader>Pending batches</ModalOrDrawerHeader>
        <DefaultContent />
        <ModalFooter>
          <Button onClick={onClose}>{t('Close')}</Button>
        </ModalFooter>
      </ModalOrDragDrawerContent>
    </ModalOrDrawer>
  );
};
